import { SendRecommendedNotificationActionStep } from '../../types/journey-nodes'
import { BlueConicRecommendedNotificationParams } from '@pushly/models/lib/structs/journeys'
import { simpleNotification } from '@pushly/aqe/lib/utils'
import { extractFriendlyErrorMessage } from '../../../../exceptions/helpers'

export const validateRecommendedNotification = (
    params: SendRecommendedNotificationActionStep['configuration']['params'],
): [boolean, string] => {
    let isValid = true
    let errorMessage
    let validModel: BlueConicRecommendedNotificationParams | undefined
    try {
        validModel = params.validate()
    } catch (error) {
        const displayError = extractFriendlyErrorMessage(error, {
            fieldNamesMap: {
                recommendation_source: 'Recommendation Source',
                recommendation_config: 'Recommendation Configuration',
                'recommendation_config.*.boosts': 'Recommendation Configuration boost',
                'recommendation_config.*.boosts.*.value': 'Boost value',
                'recommendation_config.*.boosts.*.rampUp': 'Boost ramp up',
                'recommendation_config.*.boosts.*.algorithm': 'Boost algorithm',
                'recommendation_config.*.filters': 'Filters',
            },
            startWithProperty: true,
            rootModel: BlueConicRecommendedNotificationParams,
        })

        errorMessage = displayError.message
        isValid = false
    }

    if (validModel) {
        if (!validModel.recommendation_source) {
            errorMessage = 'Recommendation Source must be selected and configured to save this step'
            isValid = false
        } else {
            if (validModel.integration) {
                const integrationValue = validModel.integration
                if (!integrationValue.integration_id || !integrationValue.store_id) {
                    errorMessage = 'Recommendation Source must be selected and configured to save this step'
                    isValid = false
                }
            }
        }

        if (validModel.recommendation_config.length < 1) {
            errorMessage = 'There must be at least one configuration in a BlueConic Recommendation Notification'
            isValid = false
        } else {
            const boostsMissing = validModel.recommendation_config.filter((c) => !c.boosts.length)

            if (boostsMissing.length) {
                errorMessage = 'Each configuration must have at least one boost configured'
                isValid = false
            }
        }
    }

    return [isValid, errorMessage]
}
